const translations = {
	page_title: "{{productName}} - Documents de souscription",
	title: "{{productName}} - Documents de souscription",
	sub_pages: {
		corporation: {
			label: "Documents personne morale",
		},
		physical_person: {
			label: "Documents personne physique",
		},
	},
};

export default translations;
